import type { CellExecutionMetricsOverlay } from "../types";

interface PromptRequestMetricsChipProps {
  metrics?: CellExecutionMetricsOverlay | null;
}

export default function PromptRequestMetricsChip({ metrics }: PromptRequestMetricsChipProps) {
  const cost = metrics?.cost ?? null;
  const latency = metrics?.latency ?? null;

  if (!cost && !latency) {
    return null;
  }

  const detailParts = [cost ? `Cost ${cost}` : null, latency ? `Latency ${latency}` : null].filter(
    (part): part is string => part !== null,
  );

  return (
    <div
      role="note"
      className="pointer-events-none absolute bottom-1 right-1 z-20 flex max-w-[calc(100%-0.5rem)] items-center gap-1 truncate rounded-md border border-border/60 bg-background/90 px-1.5 py-0.5 text-[10px] font-medium leading-none text-muted-foreground shadow-sm backdrop-blur-sm dark:bg-background/80"
      title={detailParts.join(" · ")}
      aria-label={detailParts.join(", ")}
    >
      {cost ? <span className="truncate tabular-nums">{cost}</span> : null}
      {cost && latency ? <span className="text-muted-foreground/50">·</span> : null}
      {latency ? <span className="shrink-0 tabular-nums">{latency}</span> : null}
    </div>
  );
}
